import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AdminForm from "../../AdminForm";
import {
  fetchTag,
  setTagForEdit,
  selectLoading,
  updateTag,
  selectTagForEditing,
} from "features/admin/Tags/tagsAdminSlice";

const EditTag = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const tag = useSelector(selectTagForEditing);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchTag(id));
    return () => {
      dispatch(setTagForEdit(undefined));
    };
  }, [id]);

  const onSubmit = (data: any) => {
    const tag = { id: id, data };

    dispatch(
      updateTag(tag, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return <AdminForm formTitle="Промяна на климатик" onSubmit={onSubmit} product={tag} progress={progress} />;
};

export default EditTag;
